import { render, staticRenderFns } from "./designation-payroll.vue?vue&type=template&id=0c6e3dfb&scoped=true&"
import script from "./designation-payroll.vue?vue&type=script&lang=js&"
export * from "./designation-payroll.vue?vue&type=script&lang=js&"
import style0 from "./designation-payroll.vue?vue&type=style&index=0&id=0c6e3dfb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6e3dfb",
  null
  
)

export default component.exports